import styled from 'styled-components';

const MoveItemStyle = styled.div`
	--padItemTB: var(--sp6x);
	--padItemLR: var(--sp5x);
	--borderRadius: var(--sp3x);
	--sizeIcon: var(--sp7x);
	--distanceTitleCashback: var(--sp6x);
	--distanceCashbackLR: var(--sp1x);
	--distanceDescriptionStarting: var(--sp3x);
	--dramIconSize: var(--sp1x);
	--percentIconSize: calc(var(--sp3x) + var(--sp0-5x));
	--percentDistanceL: var(--sp1x);
	--titleIconMLR: var(--sp0-5x);

	.wrapper-item {
		height: 100%;
		padding: var(--padItemTB) var(--padItemLR);
		border: 1px solid var(--neutral600);
		border-radius: var(--borderRadius);
	}

	.title-icon {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.icon-title {
			font-size: var(--sizeIcon);
		}

		margin-bottom: var(--distanceTitleCashback);
	}

	.cashBack-text {
		margin: 0 var(--distanceCashbackLR);
	}

	.icon-percent {
		font-size: var(--percentIconSize);
		margin-left: var(--percentDistanceL);
	}

	.icon-dram {
		font-size: var(--dramIconSize);
	}

	.description,
	.starting-text {
		display: block;
	}

	.starting-text {
		margin-top: var(--distanceCashbackLR);
		padding-bottom: var(--distanceDescriptionStarting);
	}

	.description-wrapper {
		padding-top: var(--distanceDescriptionStarting);
		border-top: 1px solid var(--neutral600);
	}

	.icon-title {
		margin: 0 var(--titleIconMLR);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--padItemTB: var(--sp5x);
		--padItemLR: var(--sp4x);
		--sizeIcon: var(--sp6x);
		--percentDistanceL: var(--sp0-5x);
		--distanceDescriptionStarting: var(--sp3x);
		--percentIconSize: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--padItemTB: var(--sp4x);
		--padItemLR: var(--sp3x);
		--distanceTitleCashback: var(--sp4x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--padItemTB: var(--sp3x);
		--padItemLR: var(--sp2x);
		--distanceTitleCashback: var(--sp3x);
		--distanceDescriptionStarting: var(--sp2x);
		--percentIconSize: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--padItemLR: var(--sp1-5x);
		--distanceTitleCashback: var(--sp2-5x);
		--borderRadius: var(--sp2x);
		--percentIconSize: var(--sp2x);
		--dramIconSize: calc(var(--sp0-5x) / 2 + var(--sp0-5x));
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeIcon: var(--sp4x);
		--distanceTitleCashback: var(--sp3x);
		--distanceCashbackLR: var(--sp0-5x);
		--percentIconSize: var(--sp1-5x);
		--titleIconMLR: var(--sp1x);

		.text-percent-all {
			margin-bottom: var(--sp1x);
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default MoveItemStyle;
